import React from "react";
import {Images} from "../controller/Images";
import {Link} from "react-router-dom";
import {nameCode} from "../controller/Utils";
import Button from "../../node_modules/antd/es/button/button";
import {AddCall} from "./ab-marketing/popup/AddCall";

function toggleSideBar() {
  var ww = document.body.clientWidth;
  if (ww > 1150) {
    const left = document.getElementById("left-sidebar");
    left.classList.toggle("small-side-bar");
    const nav = document.getElementById('nav-fixed-top');
    nav.classList.toggle('toggle-nav');
    const rootELe = document.getElementById('root');
    rootELe.classList.toggle('toggle-all');
  }
  else {
    const left = document.getElementById("left-sidebar");
    left.classList.toggle("small-side-bar-mobile");
  }
}

export class Header extends React.Component {
  state = {
    addCallVisible: false
  };

  showCallModal = (visible) => {
    this.setState({addCallVisible: visible})
  };

  updateCallLog = () => {
    const element = document.getElementById('call-log-refresh');
    if (element)
      element.click();
  };

  render() {
    const user = this.props.user;
    return (
      <React.Fragment>
      <nav id="nav-fixed-top" className="navbar navbar-fixed-top">
        <div className="container-fluid">
          <div className="navbar-btn">
            <button type="button" className="btn-toggle-offcanvas">
              <i className="lnr lnr-menu fa fa-bars" />
            </button>
          </div>
          <div className="navbar-brand">
            <Link to="/dashboard/" className="pull-left logo-img">
              <img src={Images.image_logo} alt="Ab Environment Logo" className="img-fluid logo" />
            </Link>
            <button className="menu-btn btn-toggle pull-left btn-toggle-effect" onClick={toggleSideBar}>
              <div className="icon" />
            </button>
          </div>
          <div className="navbar-right">
            <div className="header-list">
              <ul>
                <li>
                  <Link to="/">
                    <img className="img-fluid" src={Images.dashboard_icon} alt="" />
                    Dashboard
                  </Link>
                </li>
                <li>
                  <a href="#">
                    <img className="img-fluid" src={Images.inbox_icon} alt="" /> Inbox
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img className="img-fluid" src={Images.task_icon} alt="" /> Tasks
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img className="img-fluid" src={Images.notepad_icon} alt="" />Notepad
                  </a>
                </li>
                <li>
                  <Button onClick={()=>this.showCallModal(true)} className="header-call-btn">New Call/Lead</Button>
                </li>
              </ul>
            </div>
            <div id="navbar-menu">
              <div className="user-account">
                <div className="dropdown">
                  <a className="dropdown-toggle user-name" data-toggle="dropdown">
                    {user.image ?
                      <img src={user.image} className="rounded-circle user-photo" alt="User Profile Picture" /> :
                      <div className="icon_div">
                        <div className="user_icon">{nameCode(user.first_name, user.last_name)}</div>
                      </div>}
                  </a>
                  <ul className="dropdown-menu dropdown-menu-right account">
                    <li>
                      <div className="user-account">
                        <span className="user-img">
                          {user.image ? <img src={user.image} className="user-photo" alt="User Profile Picture" /> :
                            <div className="icon_div">
                              <div className="user_icon">{nameCode(user.first_name, user.last_name)}</div>
                            </div>}
                        </span>
                        <a href="#" className="dropdown-toggle user-name" data-toggle="dropdown">
                          <span>{user ? user.first_name : ''} {user ? user.last_name : ''}</span>
                          <span>{user ? user.email : ''}</span>
                        </a>
                      </div>
                    </li>
                    <li>
                      <a >Profile</a>
                    </li>
                    <li>
                      <Link to="/dashboard/settings/" >Setting</Link>
                    </li>
                    <li>
                      <Link to="/logout/">
                        <i className="icon-power" />
                        Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="plus-icon">
              <div className="user-account">
                <div className="dropdown">
                  <a href="#" className="dropdown-toggle header-plus btn-toggle-effect user-name" data-toggle="dropdown">
                    <i className="fa fa-plus" />
                  </a>
                  <ul className="dropdown-menu dropdown-menu-right account">
                    <li>
                      <Link to="/dashboard/quotes/">Quote</Link>
                    </li>
                    <li>
                      <Link to="/dashboard/work-order/">Work Order</Link>
                    </li>
                    <li>
                      <a >Hotsheet</a>
                    </li>
                    <li>
                      <a >Tasks</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <form className="search-form">
              <div className="search-bar">
                <input className="form-control" placeholder="Search" type="text" />
                <ul className="searching-list">
                  <li><a ><img className="img-fluid" alt="" src={Images.tracks_icon} /> Search in AB Tracks</a></li>
                  <li><a ><img className="img-fluid" alt="" src={Images.crm_icon} /> Search in AB CRM</a></li>
                  <li><a ><img className="img-fluid" alt="" src={Images.dispatch_image} /> Search in AB Dispatch</a></li>
                  <li><a ><img className="img-fluid" alt="" src={Images.marketing_icon} /> Search in AB Marketing</a></li>
                  <li><a ><img className="img-fluid" alt="" src={Images.analytics_icon} /> Search in AB Analytics</a></li>
                  <li><a ><img className="img-fluid" alt="" src={Images.financial_icon} /> Search in AB Finance</a></li>
                  <li><a >Advance Search</a></li>
                </ul>
              </div>
            </form>
          </div>
        </div>
      </nav>
       <AddCall visible={this.state.addCallVisible}  fetch={() => this.updateCallLog()} onClose={()=>this.showCallModal(false)} />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Header.jsx